import { useEffect } from 'react';

function useNativeListener(
    functionName: string,
    fn: Function,
    deps?: any[],
) {
    useEffect(() => {
    // @ts-ignore
        window[functionName] = fn;
        return () => {
            // @ts-ignore
            window[functionName] = undefined;
        };
    }, deps || []);
}

export default useNativeListener;
